import vanillaCountdown from 'timmitvanillacountdown/vanillaCountdown.es.js';

const countdown = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		countdown.initVanillaCountdown(target);
		countdown.initEvents();

	},

	initEvents: function() {

		$('#timeoutModalBtnContinue').on('click', function() {
			vanillaCountdown.checkStartTime($(this).data('extend-time-url'));
		});

	},

	initVanillaCountdown: function(target) {

		/** Toon de teller voor het automatisch uitloggen */
		var el = target.querySelector('#countdown');

		if (el) {

			var curtimeMSServer = $('#countdown').attr('data-cur-time') * 1000;
			var now = new Date();
			var curtimeMSClient = now.getTime();
			var offset = curtimeMSClient - curtimeMSServer;

			vanillaCountdown.init({
				seconds: $('#countdown').attr('data-seconds'),
				offset: offset,
				checkTimeUrl: $('#countdown').attr('data-check-time'),
				expireAtTimestamp: $('#countdown').attr('data-expire-time'),
				onCompleteCallBack: function() {
					var onCompleteUrl = $('#countdown').attr('data-action-url');
					if (typeof (onCompleteUrl) != 'undefined') {
						window.location.href = onCompleteUrl;
					}
				},
				partTwo: true,
				partTwoCallBack: function() {
					$('#timeoutModal').modal('show', {
						backdrop: 'static',
						keyboard: false,
						show: true
					});
				},
				checkTimeCallBack: function() {
					if (!vanillaCountdown.checkIfInPart2()) {
						$('#timeoutModal').modal('hide');
					}
				},
			});
		}

	}

};

export default countdown;
